/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AccountControllerDtoAccountCurrentNicknameUpdateRequest from '../model/AccountControllerDtoAccountCurrentNicknameUpdateRequest';
import AccountControllerDtoAccountCurrentPowerUpdateRequest from '../model/AccountControllerDtoAccountCurrentPowerUpdateRequest';
import AccountControllerDtoAccountDefaultInfoRequest from '../model/AccountControllerDtoAccountDefaultInfoRequest';
import AccountControllerDtoAccountDefaultInfoResponse from '../model/AccountControllerDtoAccountDefaultInfoResponse';
import AccountControllerDtoAccountInventoryInfoRequest from '../model/AccountControllerDtoAccountInventoryInfoRequest';
import AccountControllerDtoAccountInventoryInfoResponse from '../model/AccountControllerDtoAccountInventoryInfoResponse';
import AccountControllerDtoAccountListRequest from '../model/AccountControllerDtoAccountListRequest';
import AccountControllerDtoAccountListResponse from '../model/AccountControllerDtoAccountListResponse';
import AccountControllerDtoAccountPunishStatusUpdateRequest from '../model/AccountControllerDtoAccountPunishStatusUpdateRequest';
import AccountControllerDtoWithdrawalCancelRequest from '../model/AccountControllerDtoWithdrawalCancelRequest';
import AccountControllerDtoWithdrawalLogListRequest from '../model/AccountControllerDtoWithdrawalLogListRequest';
import AccountControllerDtoWithdrawalRequest from '../model/AccountControllerDtoWithdrawalRequest';
import BaseResponse from '../model/BaseResponse';

/**
* PerplayAccount service.
* @module api/PerplayAccountApi
* @version 1.0
*/
export default class PerplayAccountApi {

    /**
    * Constructs a new PerplayAccountApi. 
    * @alias module:api/PerplayAccountApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayAccountAccountCurrentNicknameUpdatePost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountAccountCurrentNicknameUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoAccountCurrentNicknameUpdateRequest} [accountControllerDtoAccountCurrentNicknameUpdateRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountAccountCurrentNicknameUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayAccountAccountCurrentNicknameUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoAccountCurrentNicknameUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/AccountCurrentNicknameUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountAccountCurrentPowerUpdatePost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountAccountCurrentPowerUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoAccountCurrentPowerUpdateRequest} [accountControllerDtoAccountCurrentPowerUpdateRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountAccountCurrentPowerUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayAccountAccountCurrentPowerUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoAccountCurrentPowerUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/AccountCurrentPowerUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountAccountDefaultInfoPost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountAccountDefaultInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountControllerDtoAccountDefaultInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoAccountDefaultInfoRequest} [accountControllerDtoAccountDefaultInfoRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountAccountDefaultInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountControllerDtoAccountDefaultInfoResponse}
     */
    apiPerplayAccountAccountDefaultInfoPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoAccountDefaultInfoRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = AccountControllerDtoAccountDefaultInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/AccountDefaultInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountAccountInventoryInfoPost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountAccountInventoryInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoAccountInventoryInfoRequest} [accountControllerDtoAccountInventoryInfoRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountAccountInventoryInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountControllerDtoAccountInventoryInfoResponse}
     */
    apiPerplayAccountAccountInventoryInfoPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoAccountInventoryInfoRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = AccountControllerDtoAccountInventoryInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/AccountInventoryInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountAccountListPost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountAccountListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountControllerDtoAccountListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoAccountListRequest} [accountControllerDtoAccountListRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountAccountListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountControllerDtoAccountListResponse}
     */
    apiPerplayAccountAccountListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoAccountListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = AccountControllerDtoAccountListResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/AccountList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountAccountPunishStatusUpdatePost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountAccountPunishStatusUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoAccountPunishStatusUpdateRequest} [accountControllerDtoAccountPunishStatusUpdateRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountAccountPunishStatusUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayAccountAccountPunishStatusUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoAccountPunishStatusUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/AccountPunishStatusUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountWithdrawalCancelPost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountWithdrawalCancelPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoWithdrawalCancelRequest} [accountControllerDtoWithdrawalCancelRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountWithdrawalCancelPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayAccountWithdrawalCancelPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoWithdrawalCancelRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/WithdrawalCancel', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountWithdrawalLogListPost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountWithdrawalLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoWithdrawalLogListRequest} [accountControllerDtoWithdrawalLogListRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountWithdrawalLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayAccountWithdrawalLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoWithdrawalLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/WithdrawalLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayAccountWithdrawalPost operation.
     * @callback module:api/PerplayAccountApi~apiPerplayAccountWithdrawalPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountControllerDtoWithdrawalRequest} [accountControllerDtoWithdrawalRequest] 
     * @param {module:api/PerplayAccountApi~apiPerplayAccountWithdrawalPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayAccountWithdrawalPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['accountControllerDtoWithdrawalRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayAccount/Withdrawal', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
